import { AnalysisDosingFrequency, AnalysisDosingFrequencyType } from "@/enums";
import { AplosAnalysisConfiguration } from "@/types";



export class AnalysisConfigurationFactory {

    public static createNewAnalysisConfiguration(): AplosAnalysisConfiguration & any {
        const configuration = {
            version: "",
            designations: {
                blq: { value: "BLQ", column: undefined },
                missing: { value: "NS", column: undefined },
                concentrationUnit: { value: "ng/mL", column: undefined },
            },
            columns: {
                time: undefined as any,
                uniqueId: undefined as any,
                concentration: {
                    observed: "",
                    analyzed: "",
                },
                sorting: [],
                grouping: [],
                customColumns: [],
            },
            dosing: {
                amount: { value: "1", column: undefined },
                unit: { value: "mg", column: undefined },
                frequency: { value: AnalysisDosingFrequency.Single, column: undefined },
                type: { value: AnalysisDosingFrequencyType.Ev, column: undefined }
            },
            time: {
                unit: { value: "hr", column: undefined },
                timeOfAdministration: { value: 0, column: undefined },
                tau: { value: 24, column: undefined },
                infusion: {
                    protocol: { value: "rate", column: undefined },
                    amount: { value: "1", column: undefined },
                },
            },
            kelRules: {
                kelMethod: 1,
                regressionStatistic: "adj_r2",
                minimumStatistic: 0,
                maximumExtrapolationLinear: 0,
                maximumExtrapolationLogarithmic: 0,
                maximumTimePoints: 0,
                minimumSpan: 0,
                earliestTimePoint: 0,
                tie: ["kel_n", "kel_lower"],
            },
            partialAuc: [],
            sparseData: false
        } as AplosAnalysisConfiguration & any;

        return configuration;
    }

}